"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _stylitas = require("@creditas/stylitas");

const container = () => (0, _stylitas.css)`
  width: 100%;
  display: flex;
  align-items: center;
`;

const verticalAligment = () => (0, _stylitas.css)`
  flex-direction: column;
  align-items: flex-start;
`;

const Container = _stylitas.styled.div`
  ${container};
  ${props => props.vertical && verticalAligment}
`;
exports.Container = Container;